import type { SVGProps } from "react"

export default function ShareWhatsApp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0833 3C7.56049 3 3.08333 7.47716 3.08333 13C3.08333 14.9542 3.64583 16.7708 4.625 18.3125L3.08333 23L7.89583 21.4896C9.38542 22.3854 11.1458 22.9167 13.0833 22.9167C18.6062 22.9167 23.0833 18.4395 23.0833 12.9167C23.0833 7.47716 18.6062 3 13.0833 3ZM10.0417 8.16667C9.85417 7.72917 9.64583 7.75 9.375 7.75C9.14583 7.75 8.83333 7.83333 8.54167 8.14583C8.25 8.45833 7.41667 9.25 7.41667 10.8542C7.41667 12.4583 8.5625 14 8.72917 14.2292C8.89583 14.4583 10.9583 17.8125 14.1667 19.0417C16.7292 20.0208 17.3542 19.7917 17.9375 19.7292C18.5208 19.6667 19.8542 18.8958 20.1042 18.1042C20.3542 17.3125 20.3542 16.625 20.2708 16.5C20.1875 16.375 20 16.2917 19.7083 16.1458C19.4167 16 17.8333 15.2083 17.5625 15.1042C17.2917 15 17.1042 14.9583 16.9167 15.25C16.7292 15.5417 16.125 16.2917 15.9583 16.4792C15.7917 16.6667 15.625 16.6875 15.3333 16.5417C15.0417 16.3958 13.9792 16.0208 12.7292 14.9167C11.75 14.0417 11.0833 12.9583 10.9167 12.6667C10.75 12.375 10.8958 12.2083 11.0417 12.0625C11.1875 11.9167 11.375 11.6875 11.5208 11.5208C11.6667 11.3542 11.7292 11.2292 11.8125 11.0417C11.8958 10.8542 11.8542 10.6875 11.7708 10.5417C11.6875 10.3958 11.1042 8.78125 10.0417 8.16667Z"
        fill="#25D366"
      />
    </svg>
  )
}
